import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { CurrentUser } from '../../core/models/currentuser.models';
import { AccessRight } from '../../core/models/accessrights.models';
import { TokenStorageService } from '../../core/services/token-storage.service';
import { ActionsSubject, Store } from '@ngrx/store';
import { getCountsData, getCountsDataError, getCountsDataLoading } from '../../store/common/common.selector';
import { fetchCounts, fetchStampingPartnerCounts } from '../../store/common/common.actions';
import { GlobalComponent } from '../../global-component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GenericService } from '../../core/services/generic.service';
import { EventService } from '../../core/services/event.service';
import { skip } from 'rxjs';
@UntilDestroy()
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  menu: any;
  toggle: any = true;
  userData: any;
  menuItems!: AccessRight[];
  currentUser!: CurrentUser;
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  roles = GlobalComponent.ROLES;

  vendoruniquekey = environment.vendoruniquekey;

  constructor(private router: Router, private tokenService: TokenStorageService, private store: Store,
    private genericService: GenericService, private eventService: EventService, private actionListener$: ActionsSubject,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.userData = this.tokenService.getUser();
    console.log("user", this.userData);
    this.menuItems = this.userData.accessrights;
    console.log("menuitems", this.menuItems);
    this.router.events.subscribe((event) => {
      if (document.documentElement.getAttribute('data-layout') != "twocolumn") {
        if (event instanceof NavigationEnd) {
          this.initActiveMenu();
        }
      }
    });

    this.registerActionListener();

    // this.fetchCounts();
    if(this.userData.usertype == 'stampingpartner') {
      this.store.dispatch(fetchStampingPartnerCounts());
    } else {
      this.store.dispatch(fetchCounts());
    }
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.initActiveMenu();
    }, 0);

    this.eventService.subscribe(GlobalComponent.broadcasts.updateunreadchatscount, value => {
      this.menuItems.forEach((res) => {
        if (res.key_label === 'inbox') {
          res.count = value > 0 ? value : undefined;
        }
      });
      this.changeDetectorRef.markForCheck();
    });
  }


  removeActivation(items: any) {
    items.forEach((item: any) => {
      item.classList.remove("active");
    });
  }


  toggleItem(item: any) {
    this.menuItems.forEach((menuItem: any) => {

      if (menuItem == item) {
        menuItem.isCollapsed = !menuItem.isCollapsed
      } else {
        menuItem.isCollapsed = true
      }
      if (menuItem.subItems) {
        menuItem.subItems.forEach((subItem: any) => {

          if (subItem == item) {
            menuItem.isCollapsed = !menuItem.isCollapsed
            subItem.isCollapsed = !subItem.isCollapsed
          } else {
            subItem.isCollapsed = true
          }
          if (subItem.subItems) {
            subItem.subItems.forEach((childitem: any) => {

              if (childitem == item) {
                childitem.isCollapsed = !childitem.isCollapsed
                subItem.isCollapsed = !subItem.isCollapsed
                menuItem.isCollapsed = !menuItem.isCollapsed
              } else {
                childitem.isCollapsed = true
              }
              if (childitem.subItems) {
                childitem.subItems.forEach((childrenitem: any) => {

                  if (childrenitem == item) {
                    childrenitem.isCollapsed = false
                    childitem.isCollapsed = false
                    subItem.isCollapsed = false
                    menuItem.isCollapsed = false
                  } else {
                    childrenitem.isCollapsed = true
                  }
                })
              }
            })
          }
        })
      }
    });
  }


  // remove active items of two-column-menu
  activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  updateActive(event: any) {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
  }

  initActiveMenu() {
    let pathName = window.location.pathname;
    // Check if the application is running in production
    if (environment.production) {
      // Modify pathName for production build
      pathName = pathName.replace('/velzon/angular/modern', '');
    }

    const active = this.findMenuItem(pathName, this.menuItems)
    this.toggleItem(active)
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      let activeItems = items.filter((x: any) => x.classList.contains("active"));
      this.removeActivation(activeItems);

      let matchingMenuItem = items.find((x: any) => {
        if (environment.production) {
          let path = x.pathname
          path = path.replace('/velzon/angular/modern', '');
          return path === pathName;
        } else {
          return x.pathname === pathName;
        }

      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }
  private findMenuItem(pathname: string, menuItems: any[]): any {
    for (const menuItem of menuItems) {
      if (menuItem.link && menuItem.link === pathname) {
        return menuItem;
      }

      if (menuItem.subItems) {
        const foundItem = this.findMenuItem(pathname, menuItem.subItems);
        if (foundItem) {
          return foundItem;
        }
      }
    }

    return null;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: AccessRight) {
    return false;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    var sidebarsize = document.documentElement.getAttribute("data-sidebar-size");
    if (sidebarsize == 'sm-hover-active') {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover')
    } else {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover-active')
    }
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    document.body.classList.remove('vertical-sidebar-enable');
  }

  // fetchCounts() {
  //   this.store.select(getCountsDataLoading).pipe(untilDestroyed(this)).subscribe((loading) => {
  //     // this.isloading = loading;
  //   });

  //   this.store.select(getCountsData).pipe(untilDestroyed(this)).subscribe((data: any) => {
  //     if (data && data.servicecounts) {
  //       this.menuItems.map((res) => {
  //         if (res.key_label == 'planset') {
  //           res.count = data.servicecounts.plansets;
  //         } else if (res.key_label == 'salesproposal') {
  //           res.count = data.servicecounts.salesproposal;
  //         } else if (res.key_label == 'pestamp') {
  //           res.count = data.servicecounts.pestamps;
  //         } else {
  //         }
  //       })
  //     }
  //   });

  //   this.store.select(getCountsDataError).pipe(untilDestroyed(this)).subscribe((data) => {
  //     if (data) {
  //     }
  //   });

  //   this.store.dispatch(fetchCounts());
  // }

  registerActionListener() {
    this.actionListener$.pipe(untilDestroyed(this)).pipe(
      skip(1) // optional: skips initial logging done by ngrx
    ).subscribe((action: any) => {
      console.info('ngrx action', action);
      switch (action.type) {
        case "[Common] Fetch Counts Success":
          {
            let data = action.countsobj;
            this.genericService.savecountsdatalocally(data);
            this.eventService.broadcast(GlobalComponent.broadcasts.updateallcounts, data);
            console.log("data.....////////////", data);
            console.log("menu items..", this.menuItems);
            if (data && data.servicecounts) {
              this.menuItems.map((res) => {
                if (res.key_label == 'planset') {
                  res.count = data.servicecounts.plansets;
                } else if (res.key_label == 'salesproposal') {
                  res.count = data.servicecounts.salesproposal;
                } else if (res.key_label == 'pestamp') {
                  res.count = data.servicecounts.pestamps;
                } else if (res.key_label == 'pto') {
                  res.count = data.servicecounts.ptos;
                } else if (res.key_label == 'survey') {
                  res.count = data.servicecounts.surveys;
                } else if (res.key_label == 'permitting') {
                  res.count = data.servicecounts.permittings;
                } else {
                }
              });
            }
            break;
          }

        case "[Common] Fetch Stamping Partner Counts Success": {
          let data = action.countsobj;
          this.genericService.savecountsdatalocally(data);
          this.eventService.broadcast(GlobalComponent.broadcasts.updateallcounts, data);
          if (data && data.servicecounts) {
            this.menuItems.map((res) => {
              if (res.key_label == 'planset') {
                res.count = data.servicecounts.plansets;
              } else if (res.key_label == 'salesproposal') {
                res.count = data.servicecounts.salesproposal;
              } else if (res.key_label == 'pestamp') {
                res.count = data.servicecounts.pestamps;
              } else {
              }
            })
          }
          break;
        }
        default:
          break;
      }
    });
  }
}
